import { render, staticRenderFns } from "./Traditional.vue?vue&type=template&id=16aebd9a&scoped=true&"
import script from "./Traditional.vue?vue&type=script&lang=js&"
export * from "./Traditional.vue?vue&type=script&lang=js&"
import style0 from "./Traditional.vue?vue&type=style&index=0&id=16aebd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aebd9a",
  null
  
)

export default component.exports